import React from "react";
import Podium from "./Podium";
import RankRest from "./RankRest";
import KpiStrip from "./KpiStrip";

// Kolom 2 - de ranglijst van deze maand, met onderaan drie kerncijfers.
// De kaart wisselt tussen het podium (top 3) en "Andere verkopers".
//
// React.memo: zonder dat mount React de kaart bij elke klok-tick opnieuw en
// speelt de fade-in van alle rijen weer af, alsof de kaart herlaadt.
const MonthlyRankList = React.memo(
  ({ rankList, rankView, now, bestSeller, previousMonth, deals, existantDeals }) => {
    const rest = rankList.slice(3);
    const showRest = rest.length > 0 && rankView === "rest";
    const sellerCount = `${rankList.length} ${rankList.length === 1 ? "verkoper" : "verkopers"}`;

    return (
      <div className="card rank-column">
        <div className="card-head">
          <h3 className="card-title">
            {showRest ? (
              "Andere verkopers"
            ) : (
              <>
                Ranglijst van <span className="hl">{now.toUpperCase()}</span>
              </>
            )}
          </h3>
          <h3 className="card-title">
            {showRest ? `nr. 4 t/m ${rankList.length}` : sellerCount}
          </h3>
        </div>

        {rankList.length === 0 && (
          <div className="empty-note">Nog geen verkopen in {now}</div>
        )}
        {rankList.length > 0 && !showRest && <Podium rankList={rankList} />}
        {showRest && <RankRest rest={rest} />}

        <KpiStrip
          bestSeller={bestSeller}
          previousMonth={previousMonth}
          deals={deals}
          existantDeals={existantDeals}
        />
      </div>
    );
  },
);

export default MonthlyRankList;
